import type { ModelPosition, StockPosition, TextPosition } from '../../../domain/positions';

/**
 * The CreatePositionRendererEvent is dispatched when the user submits the row they have filled in.
 *
 * It carries a position rather than the fields it was read from, so a listener never has to know how the row is laid out. The row only dispatches it once it holds a whole position, so the position is always there — Enter is refused until it is.
 */
export default class CreatePositionRendererEvent extends Event {
	/**
	 * The static POSITION_CREATED type is dispatched when the user submits a filled in row.
	 *
	 * Example: addEventListener(CreatePositionRendererEvent.POSITION_CREATED, (event: CreatePositionRendererEvent) => {});
	 */
	public static POSITION_CREATED = 'CreatePositionRendererEvent.positionCreated';
	/** The position the row was filled in as. */
	public get position(): ModelPosition | StockPosition | TextPosition {
		return this.#position;
	}

	#position: ModelPosition | StockPosition | TextPosition;

	public constructor(position: ModelPosition | StockPosition | TextPosition) {
		super(CreatePositionRendererEvent.POSITION_CREATED, { bubbles: true });
		this.#position = position;
	}
}
